/* eslint-disable max-len */
// @flow
import { connect } from 'react-redux';
import _ from 'lodash';
import * as React from 'react';
import cn from 'classnames';
import ReactSelect, { components } from 'react-select';

import LeadCreatedPopUp from 'client/components/common/LeadCreatedPopUp';

import { /* APP_CONFIG, */ LEAD_CONSTANTS } from 'common/constants';

import { COLLECTIONS } from 'client/constants';
import { Responsive, Icon } from 'client/components/common';
import { createItem, updateRealTimeDataBase } from 'client/actions';
import { dataLayerEvents } from 'common/utils/gtag';

import uploadIcon from 'assets/client/images/firstScreen/upload.png';
import checkIcon from 'assets/client/images/createLeadPopUp/check.png';
import * as css from './ContentForm.scss';

const TURNSTILE_CONTAINER_ID = 'turnstile-container';
type FormDataType = {
	nameOfTheCandle?: string,
	birthYear?: {
		value: string,
		label: string,
	},
	deathYear?: {
		value: string,
		label: string,
	},
	freeText?: string,
	mainPicture?: FileURL,
	profilePicture?: FileURL,
	senderName?: string,
};

type Props = {
	values: FormDataType,
	errors: FormDataType,
	createItem: typeof createItem,
	// updateRealTimeDataBase: typeof updateRealTimeDataBase,
	setActiveCreateLeadPopUp: any,
};

type State = {
	isShowSentFormPopup: boolean,
	isLoading: boolean,
	nameOfTheCandleValue: string,
	senderName: string,
	profilePictures: File[],
	mainPicture: File | null,
	freeText: string,
	mainPictureError: string,
	profilePicturesError: string,
	nameOfTheCandleError: string,
};

class ContentForm extends React.PureComponent<Props, State> {
	// turnstileWidgetId = null;
	pendingPayload = null;

	// turnstileRef = React.createRef();

	static defaultProps = {
		// className: '',
	};

	constructor(props: Props) {
		super(props);
		this.state = {
			isShowSentFormPopup: false,
			isLoading: false,
			nameOfTheCandleValue: '',
			mainPicture: null,
			profilePictures: [],
			freeText: '',
			senderName: '',
			profilePicturesError: '',
			nameOfTheCandleError: '',
			mainPictureError: '',
		};
	}

	componentDidMount() {
		// this.turnstileWidgetId = window.turnstile.render(`#${TURNSTILE_CONTAINER_ID}`, {
		// 	sitekey: APP_CONFIG.turnstileSiteKey,
		// 	execution: 'execute',
		// 	appearance: 'interaction-only',
		// 	callback: this.handleTurnstileSuccess,
		// 	'error-callback': this.onTurnstileError,
		// 	'expired-callback': this.onTurnstileExpire,
		// });
	}

	componentWillUnmount() {
		// if (this.turnstileWidgetId && window.turnstile) {
		// 	window.turnstile.remove(this.turnstileWidgetId);
		// 	this.turnstileWidgetId = null;
		// }
	}

	initFormValues = async () => {};

	onClickCloseCreatedPopUp = () => {
		this.setState({ isShowSentFormPopup: false });
	};

	profilePicturesValidation = profilePictures => {
		let error = '';

		if (profilePictures.length > 5) {
			error = `מקסימום 4 קבצים`;
		} else if (profilePictures.length > 0 && profilePictures.length <= 5) {
			_.map(profilePictures, i => {
				if (i.size > 5 * (1024 * 1024)) {
					error = `יש לצרף תמונה בגודל של עד 5 מגה`;
				}
			});
		} else {
			error = '';
		}

		this.setState({ profilePicturesError: error });
	};

	mainPictureValidation = file => {
		let error = '';

		if (file.size > 5 * (1024 * 1024)) {
			error = `יש לצרף תמונה בגודל של עד 5 מגה`;
		} else {
			error = '';
		}

		this.setState({ mainPictureError: error });
	};

	getYears = (a: number, b: number) => {
		const yearsArr: any = [];

		for (let i = 0; i <= b - a; i += 1) {
			const year = (a + i).toString();

			yearsArr.push({ value: year, label: year });
		}
		// yearsArr.reverse();
		return yearsArr;
	};

	handleSubmit = async e => {
		e.preventDefault();

		this.setState({ isLoading: true });

		const { profilePicturesError, mainPictureError } = this.state;
		const formData = new FormData(e.target);

		const payload = Array.from(formData.entries()).reduce((acc, [key, value]) => {
			if (key === 'mainPicture') {
				acc[key] = value instanceof File && value.size > 0 && this.state.mainPicture ? value : null;
			} else if (key === 'profilePictures') {
				acc[key] = [...this.state.profilePictures];
			} else {
				acc[key] = value;
			}

			return acc;
		}, {});

		this.pendingPayload = payload;

		if (!payload.nameOfTheCandle) {
			this.setState({
				nameOfTheCandleError: 'יש להזין שם מלא',
				isLoading: false,
			});
			return;
		}

		if (!profilePicturesError && !mainPictureError) {
			const leadResult = await this.props.createItem<any>({
				collection: COLLECTIONS.LEADS,
				data: this.pendingPayload,
				token: 'token',
			});

			if (leadResult.data.success && leadResult.data.data.lead === LEAD_CONSTANTS.CREATED) {
				this.setState({
					isShowSentFormPopup: true,
					isLoading: false,
				});

				dataLayerEvents.onFormSent();
			} else {
				this.setState({ isLoading: false });
			}
		} else {
			this.setState({ isLoading: false });
		}

		// window.turnstile.execute(this.turnstileWidgetId);
	};

	// handleTurnstileSuccess = async (token: string) => {
	// 	if (!this.pendingPayload) {
	// 		this.setState({ isLoading: false });
	// 		return;
	// 	}

	// 	const { profilePicturesError, mainPictureError } = this.state;

	// 	if (!profilePicturesError && !mainPictureError) {
	// 		const leadResult = await this.props.createItem<any>({
	// 			collection: COLLECTIONS.LEADS,
	// 			data: this.pendingPayload,
	// 			token,
	// 		});

	// 		if (leadResult.data.success && leadResult.data.data.lead === LEAD_CONSTANTS.CREATED) {
	// 			this.setState({
	// 				isShowSentFormPopup: true,
	// 				isLoading: false,
	// 			});

	// 			dataLayerEvents.onFormSent();
	// 		}
	// 	} else {
	// 		this.setState({ isLoading: false });
	// 	}

	// 	// cleanup
	// 	this.pendingPayload = null;

	// 	if (this.turnstileWidgetId && window.turnstile) {
	// 		window.turnstile.reset(this.turnstileWidgetId);
	// 	}
	// };

	// onTurnstileError = () => {
	// 	this.setState({ isLoading: false });
	// };

	// onTurnstileExpire = () => {
	// 	this.setState({ isLoading: false });
	// 	window.turnstile.reset(this.turnstileWidgetId);
	// };

	render() {
		const {
			isLoading,
			isShowSentFormPopup,
			nameOfTheCandleValue,
			mainPicture,
			freeText,
			profilePictures,
			senderName,
			profilePicturesError,
			nameOfTheCandleError,
			mainPictureError,
		} = this.state;

		const isMobile = Responsive.isMatching(Responsive.MOBILE);

		const mainPicturePlaceholder = `<strong>העלו תמונה ראשית עד 5MB</strong>`;
		const profilePicturePlaceholder = `כאן תוכלו לעלות<br>עוד 4 תמונות נוספות עד 5MB`;
		const placeholderNameOfTheCandle = 'שם הנופל/ת (שדה חובה)';

		return (
			<div className={css.formWrapper}>
				<form className={css.form} onSubmit={this.handleSubmit}>
					<div id={TURNSTILE_CONTAINER_ID} />
					<div className={css.formInner} style={{ display: isShowSentFormPopup && 'none' }}>
						<div className={css.row}>
							<div
								className={cn(css.fieldWrapper, css.nameFieldWrapper)}
								onClick={() => {
									this.setState({ nameOfTheCandleError: '' });
								}}
							>
								<label className={cn(css.textField, css.name)}>
									{!nameOfTheCandleValue && <div className={css.placeholder}>{placeholderNameOfTheCandle}</div>}
									<input
										name="nameOfTheCandle"
										value={nameOfTheCandleValue}
										onChange={e => this.setState({ nameOfTheCandleValue: e.currentTarget.value })}
									/>
								</label>
								{nameOfTheCandleError && <p className={css.error}>{nameOfTheCandleError}</p>}
							</div>

							<ReactSelect
								name="birthYear"
								// onBlur={(e: any) => _.invoke(props, 'input.onBlur', e)}
								options={this.getYears(1890, 2026)}
								placeholder="שנת לידה"
								classNamePrefix="react-select"
								components={{
									DropdownIndicator: CustomDropdownIndicator,
								}}
								styles={{
									option: (provided, { isSelected }) => ({
										...provided,
										background: isSelected ? 'rgb(214, 214, 214)' : '#fff',
										color: '#414141',
									}),
									singleValue: (provided, state) => {
										const opacity = state.isDisabled ? 0.5 : 1;
										const transition = 'opacity 300ms';

										return { ...provided, opacity, transition };
									},
								}}
								className={css.selectC}
							/>

							<ReactSelect
								name="deathYear"
								options={this.getYears(1890, 2026)}
								placeholder="שנת פטירה"
								classNamePrefix="react-select"
								components={{
									DropdownIndicator: CustomDropdownIndicator,
								}}
								styles={{
									option: (provided, { isSelected }) => ({
										...provided,
										background: isSelected ? 'rgb(214, 214, 214)' : '#fff',
										color: '#414141',
									}),
									singleValue: (provided, state) => {
										const opacity = state.isDisabled ? 0.5 : 1;
										const transition = 'opacity 300ms';

										return { ...provided, opacity, transition };
									},
								}}
								className={css.selectC}
							/>
						</div>
						<div className={css.row}>
							<label className={cn(css.textField, css.textArea)}>
								{!freeText && <div className={cn(css.placeholder, css.textareaPlaceholder)}>מילים לזיכרון</div>}
								<textarea
									name="freeText"
									value={freeText}
									onChange={e => this.setState({ freeText: e.currentTarget.value })}
								/>
							</label>
						</div>
						<div className={css.row}>
							<div className={cn(css.mediaField, css.mainPicture)}>
								<div className={cn(css.fileOutOfLimit, mainPictureError && css.fileOutOfLimitActive)}>
									{mainPictureError}
								</div>
								<label className={cn(css.controlLabel)} htmlFor="mainPictureID">
									<div className={css.fileNameWrapper}>
										<div className={css.text}></div>
										<div className={css.buttonPlus}>
											<img src={uploadIcon} alt="Upload" />
										</div>
									</div>
									{/* eslint-disable-next-line react/no-danger */}
									<div className={css.placeholder} dangerouslySetInnerHTML={{ __html: mainPicturePlaceholder }} />
									<input
										id="mainPictureID"
										name="mainPicture"
										type="file"
										accept="image/*"
										onChange={e => {
											this.setState({ mainPicture: e.currentTarget?.files[0] });
											this.mainPictureValidation(e.currentTarget.files[0]);
										}}
									/>
								</label>
								<div className={css.uploadedFiles}>
									<button className={css.file} type="button" onClick={() => this.setState({ mainPicture: null })}>
										{mainPicture && mainPicture.name && (
											<>
												<img src={checkIcon} alt="check" /> <span>{mainPicture.name}</span>
											</>
										)}
									</button>
								</div>
							</div>

							<div className={cn(css.mediaField, css.profilePictures)}>
								<div className={cn(css.profilePicturesError, profilePicturesError && css.active)}>
									{profilePicturesError}
								</div>
								<label className={cn(css.controlLabel)} htmlFor="profilePicturesID">
									<div className={css.fileNameWrapper}>
										<div className={css.text}></div>
										<div className={css.buttonPlus}>
											<img src={uploadIcon} alt="Upload" />
										</div>
									</div>
									{isMobile && profilePicturesError ? null : (
										// eslint-disable-next-line react/no-danger
										<div className={css.placeholder} dangerouslySetInnerHTML={{ __html: profilePicturePlaceholder }} />
									)}

									<input
										id="profilePicturesID"
										name="profilePictures"
										type="file"
										accept="image/*"
										multiple
										onChange={e => {
											this.setState({ profilePictures: e.currentTarget.files });
											this.profilePicturesValidation(e.currentTarget.files);
										}}
									/>
								</label>
								<div className={cn(css.uploadedFiles)}>
									{_.map(profilePictures, (item, index: number) => {
										return (
											<div key={`${item.name}|${index}`}>
												{item.name && (
													<button
														className={cn(css.file, item.size > 5 * (1024 * 1024) && css.error)}
														type="button"
														onClick={() => {
															const filteredFiles = _.remove(
																[...profilePictures],
																(i: any) => i.name !== item.name
															);
															this.setState({ profilePictures: filteredFiles });
															this.profilePicturesValidation(filteredFiles);
														}}
													>
														{item.name && (
															<>
																<img src={checkIcon} alt="check" /> <span>{item.name}</span>
															</>
														)}
													</button>
												)}
											</div>
										);
									})}
								</div>
							</div>

							<label className={cn(css.textField, css.senderName)}>
								{!senderName && <div className={css.placeholder}>שם הכותב/ת</div>}
								<input
									name="senderName"
									type="text"
									value={senderName}
									onChange={e => this.setState({ senderName: e.currentTarget.value })}
								/>
							</label>
						</div>
						<button type="submit" className={css.submitButton} disabled={isLoading}>
							{!isLoading ? (
								<>
									<span>שליחה</span>
									<Icon type="arrow-left" />
								</>
							) : (
								<div className={css.ldsRipple}>
									<div></div>
									<div></div>
								</div>
							)}
						</button>
						<div className={css.bottomText}>
							אין לעלות תמונות ומידע הסותרים את{' '}
							<a href="https://z.ynet.co.il/short/content/2018/privacypolicy/terms.html" target="_blank" rel="noreferrer">
								התקנון
							</a>
						</div>
					</div>
				</form>

				<LeadCreatedPopUp
					setActiveLeadCreatedPopUp={() => this.onClickCloseCreatedPopUp()}
					setActiveCreateLeadPopUp={this.props.setActiveCreateLeadPopUp}
					activeLeadCreatedPopUp={this.state.isShowSentFormPopup}
				/>
			</div>
		);
	}
}

const MyCustomIcon = () => (
	<svg width="14" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			d="M1.62386 0.355356C1.56021 0.29521 1.48534 0.248191 1.40352 0.21698C1.3217 0.18577 1.23453 0.17098 1.147 0.173457C1.05946 0.175933 0.973275 0.195626 0.893351 0.231412C0.813427 0.267198 0.741335 0.318375 0.681189 0.382023C0.621044 0.44567 0.574024 0.520541 0.542813 0.60236C0.511603 0.684179 0.496814 0.771344 0.49929 0.858879C0.501766 0.946414 0.521459 1.0326 0.557245 1.11253C0.593031 1.19245 0.644209 1.26454 0.707856 1.32469L6.70786 6.99136C6.83164 7.10838 6.99552 7.17358 7.16586 7.17358C7.3362 7.17358 7.50008 7.10838 7.62386 6.99136L13.6245 1.32469C13.6896 1.26494 13.7421 1.19286 13.779 1.11265C13.816 1.03243 13.8366 0.945668 13.8398 0.857405C13.8429 0.769142 13.8285 0.681136 13.7973 0.598498C13.7661 0.51586 13.7189 0.440238 13.6582 0.376024C13.5976 0.31181 13.5248 0.260285 13.4441 0.224441C13.3634 0.188597 13.2763 0.169148 13.188 0.167225C13.0997 0.165302 13.0119 0.180943 12.9297 0.213239C12.8475 0.245535 12.7726 0.293842 12.7092 0.355356L7.16586 5.59002L1.62386 0.355356Z"
			fill="#414141"
		/>
	</svg>
);

const CustomDropdownIndicator = props => {
	return (
		<components.DropdownIndicator {...props}>
			<MyCustomIcon />
		</components.DropdownIndicator>
	);
};

type FormComponentProps = {
	className?: string,
	children?: React.Node,
	handleSubmit: Function,
	onSubmit: Function,
};

const FormComponent = (props: FormComponentProps) => {
	return (
		<form className={props.className} onSubmit={props.handleSubmit(props.onSubmit)}>
			{props.children}
		</form>
	);
};

FormComponent.defaultProps = {
	className: '',
	children: null,
};

const mapState = (state: ClientStore) => {
	const values = 'form.userInfo.values';
	const errors = 'form.userInfo.submitErrors';

	return {
		values: _.get(state, `${values}`, {}),
		errors: _.get(state, `${errors}`, {}),
	};
};

const mapDispatch = {
	createItem,
	updateRealTimeDataBase,
};

export default connect(mapState, mapDispatch)(ContentForm);
